export default "__VITE_ASSET__bb5cc8f2__"